var TESNAV = TESNAV || {};

TESNAV.notifications = function() {

  TESNAV.notificationTogglers = jQuery('.js-toggle-notification');
  TESNAV.notificationTogglers.each(function(){

    var $this = jQuery(this);
    var toggleStateCookieName = $this.attr('data-toggle-state-cookie-name');
    //if no cookie attribute, means just show it
    if(!toggleStateCookieName) {
      $this.click();
      _mz.emit(_mze.DISPLAY, {
        source: {
          type: $this.attr('data-mzType') || 'panel',
          name: $this.attr('data-mzName') || 'panel-showed'
        }
      });
    }
    else {
      //toggle based on cookie
      if(Cookies) {
        if(!Cookies.get(toggleStateCookieName)) {
          _mz.emit(_mze.DISPLAY, {
            source: {
              type: $this.attr('data-mzType') || 'panel',
              name: $this.attr('data-mzName') || 'panel-showed'
            }
          });
          $this.click();
          $this.click(function(e){
            _mz.emit(_mze.CLOSE, {
              source: {
                type: $this.attr('data-mzType') || 'panel',
                name: $this.attr('data-mzName') || 'panel-closed'
              }
            });
            //cookie needs to be set on domain, not just sub domain
            var topLevelDomain = window.location.hostname.split('.');
            topLevelDomain.shift();
            topLevelDomain = topLevelDomain.join('.');
            Cookies.set(toggleStateCookieName, 'true', {
              domain: topLevelDomain,
              expires: '01/01/2030'
            });
          });
        }
      }
      else {
        if(window.console) console.error('No cookie plugin found. It should be included globally.')
      }
    }

  });
};
